var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('filter-select',{ref:"taskSelect",attrs:{"id":"taskSelect","placeholder":_vm.$t('task.name'),"multiple":false,"selected":_vm.selectedItem},on:{"filter":_vm.itemSearch,"changed":_vm.itemSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }